/**
 * Navigation Highlight Utility
 * Automatically adds 'active' class to navigation links based on current URL
 * WordPress version - matches URL pathnames instead of HTML filenames
 */

(function() {
  'use strict';

  const currentPath = window.location.pathname;

  function setNavLinkActive() {
    const navLinks = document.querySelectorAll('.nav-link, .mobile-nav-link, .submenu-link, .more-item-link');

    navLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (!href || href === '#') return;

      let linkPath;
      try {
        const urlObj = new URL(href, window.location.origin);
        linkPath = urlObj.pathname;
      } catch (e) {
        linkPath = href;
      }

      const isMatch = linkPath === currentPath ||
                      linkPath === currentPath.replace(/\/$/, '') ||
                      linkPath === currentPath + '/';

      const isHome = (currentPath === '/' || currentPath === '/home' || currentPath === '') &&
                     (linkPath === '/' || linkPath === '/home' || linkPath === '/cms/');

      if (isMatch || isHome) {
        link.classList.add('active');

        if (link.classList.contains('submenu-link')) {
          const parentSubmenu = link.closest('.submenu');
          if (parentSubmenu) {
            parentSubmenu.classList.add('show');
            const parentNavItem = parentSubmenu.closest('.nav-item.has-submenu');
            if (parentNavItem) {
              const parentToggle = parentNavItem.querySelector('.dropdown-toggle');
              if (parentToggle) {
                parentToggle.setAttribute('aria-expanded', 'true');
              }
            }
          }
        }

        // 处理桌面端下拉菜单
        const parentDropdown = link.closest('.dropdown-menu');
        if (parentDropdown) {
          parentDropdown.classList.add('show');
          const parentToggle = parentDropdown.previousElementSibling?.querySelector('.dropdown-toggle');
          if (parentToggle) {
            parentToggle.setAttribute('aria-expanded', 'true');
          }
        }

        // 处理移动端子菜单 - 自动展开直接父菜单（只展开一级）
        const mobileParentDropdown = link.closest('.mobile-submenu');
        if (mobileParentDropdown) {
          mobileParentDropdown.classList.add('show');

          // 找到直接父级 mobile-nav-item 并添加 expanded 类
          const parentNavItem = mobileParentDropdown.closest('.mobile-nav-item.has-submenu');
          if (parentNavItem) {
            parentNavItem.classList.add('expanded');

            // 找到 toggle 按钮并设置展开状态
            const parentToggle = parentNavItem.querySelector('.mobile-nav-toggle');
            if (parentToggle) {
              parentToggle.setAttribute('aria-expanded', 'true');

              // 如果父级还有父级（嵌套子菜单），继续向上展开
              const grandparentSubmenu = parentNavItem.closest('.mobile-submenu');
              if (grandparentSubmenu) {
                grandparentSubmenu.classList.add('show');
                const grandparentNavItem = grandparentSubmenu.closest('.mobile-nav-item.has-submenu');
                if (grandparentNavItem) {
                  grandparentNavItem.classList.add('expanded');
                  const grandparentToggle = grandparentNavItem.querySelector('.mobile-nav-toggle');
                  if (grandparentToggle) {
                    grandparentToggle.setAttribute('aria-expanded', 'true');
                  }
                }
              }
            }
          }
        }

        const moreParentDropdown = link.closest('.more-dropdown, .more-team-submenu, .more-zh-submenu, .more-zh-team-submenu');
        if (moreParentDropdown) {
          moreParentDropdown.classList.add('show');
          const moreMenuItem = moreParentDropdown.closest('.more-menu-item');
          if (moreMenuItem) {
            const moreToggle = moreMenuItem.querySelector('.more-toggle');
            if (moreToggle) {
              moreToggle.setAttribute('aria-expanded', 'true');
            }
          }

          const nestedMoreSubmenu = moreParentDropdown.closest('.more-zh-submenu');
          if (nestedMoreSubmenu) {
            nestedMoreSubmenu.classList.add('show');
            const moreZhToggle = nestedMoreSubmenu.querySelector('.more-zh-toggle');
            if (moreZhToggle) {
              moreZhToggle.setAttribute('aria-expanded', 'true');
            }
          }
        }
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setNavLinkActive);
  } else {
    setNavLinkActive();
  }
})();
